import Head from 'next/head';

import { JsonLd } from '@components/jsonLd/JsonLd';
import { RelatedContent } from '@components/relatedContent/RelatedContent';
import { ZinePostBody } from '@components/zinePostBody/ZinePostBody';
import { ZinePostHeader } from '@components/zinePostHeader/ZinePostHeader';
import { ZinePostPreview } from '@components/zinePostPreview/ZinePostPreview';

import { DatoZinePostPreview, DatoZinePostRecord } from '@interfaces';

import styles from './zine-post.module.scss';

type ZinePostProps = {
	post: DatoZinePostRecord;
	relatedPosts: DatoZinePostPreview[];
};

export const ZinePost = ({ post, relatedPosts }: ZinePostProps) => {
	return (
		<>
			<Head>
				<meta content="noarchive" name="robots" />
				<JsonLd record={post} />
			</Head>
			<article className={styles.post}>
				<ZinePostHeader className={styles.header} post={post} />
				<ZinePostBody blocks={post.blocks} className={styles.body} />
			</article>
			{relatedPosts.length ? (
				<RelatedContent className={styles.related} heading="More like this">
					{relatedPosts.map((relatedPost) => {
						return (
							<ZinePostPreview
								key={relatedPost.id}
								post={relatedPost}
								sizes="(min-width: 56.25em) 33.3333vw, 100vw"
							/>
						);
					})}
				</RelatedContent>
			) : null}
		</>
	);
};
